import { SubscriptionIntegration } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

interface CancelSubscriptionModalProps {
  subscription: SubscriptionIntegration;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (subscriptionId: number) => void;
  isLoading?: boolean;
}

export const CancelSubscriptionModal = memo(function CancelSubscriptionModal({
  subscription,
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: CancelSubscriptionModalProps) {
  const handleConfirm = () => {
    onConfirm(subscription.id);
  };

  return (
    <RedoModal
      hideCloseButton={isLoading}
      isOpen={isOpen}
      modalSize="sm"
      onModalCloseRequested={onClose}
      primaryButton={{
        text: "Cancel subscription",
        onClick: handleConfirm,
        disabled: isLoading,
        pending: isLoading,
        theme: "destructive",
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
        disabled: isLoading,
      }}
      title="Cancel subscription?"
    >
      <Flex dir="column" gap="md">
        <Text fontSize="sm" textColor="secondary">
          Are you sure you want to cancel this subscription? This action cannot
          be undone.
        </Text>
        {subscription.product && (
          <Flex dir="column" gap="xs">
            <Text fontSize="sm" fontWeight="medium">
              {subscription.product.name}
            </Text>
            <Text fontSize="sm" textColor="secondary">
              Quantity: {subscription.quantity}
            </Text>
          </Flex>
        )}
      </Flex>
    </RedoModal>
  );
});
